import { registerAction } from '../../Action'

export const CREATE_CHECKPOINTS = 'CREATE_CHECKPOINTS'

const createCheckpoints = registerAction(CREATE_CHECKPOINTS, {})

export default createCheckpoints
